import {AppContextState, AppContextAction, AppContextActionType} from './types';

const reducer = (prevState: AppContextState, action: AppContextAction) => {
  switch (action.type) {
    case AppContextActionType.CHANGE_THEME_MODE:
      return {
        ...prevState,
        currentTheme: action.theme,
        currentThemeMode: action.themeMode,
      };
  }
};
export default reducer;
